// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#not-found-img[data-v-c475e544]{width:286px}@media(min-width:768px){#not-found-img[data-v-c475e544]{width:364px}}.content[data-v-c475e544]{min-height:calc(100vh - 45px)}@media(min-width:768px){.content[data-v-c475e544]{min-height:calc(100vh - 211px)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
